import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDecimalSeparator]',
  standalone: false,
})
export class DecimalSeparatorDirective {
  private readonly ngControl = inject(NgControl);

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(',', '.');
    this.ngControl.control?.setValue(value);
  }
}
